import LESSON_SETTINGS_TYPES from "../types/lessonSettingsTypes";

const initialState = {
  loading: false,
  submitting: false,
  lessonSettings: null,
  error: null,
};

export default function lessonSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case LESSON_SETTINGS_TYPES.FETCH_PILLAR_METADATA_WITH_SCHEDULE_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LESSON_SETTINGS_TYPES.FETCH_PILLAR_METADATA_WITH_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        lessonSettings: action.payload.data,
      };

    case LESSON_SETTINGS_TYPES.FETCH_PILLAR_METADATA_WITH_SCHEDULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case LESSON_SETTINGS_TYPES.UPDATE_PILLAR_METADATA_BEGIN:
      return {
        ...state,
        submitting: true,
        error: null,
      };

    case LESSON_SETTINGS_TYPES.UPDATE_PILLAR_METADATA_SUCCESS:
      return {
        ...state,
        submitting: false,
      };

    case LESSON_SETTINGS_TYPES.UPDATE_PILLAR_METADATA_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
